import en from "./en";
import hi from "./hi";

export const languages = {
  en,
  hi
};
